<div class="row-center">
  <button
    irxBotonIcono tooltip="Notificaciones"
    [matMenuTriggerFor]="menu"
    [matBadge]="notificacionesSinLeer ? notificacionesSinLeer : null"
    matBadgePosition="above after"
    matBadgeColor="primary"
    aria-hidden="false"
  >
    <mat-icon>notifications_active</mat-icon>
  </button>
</div>

<mat-menu
  #menu="matMenu"
  xPosition="after"
  class="tabla-menu tabla-menu-flush"
>
  @if (notificacionesActivas() === false) {
    <div class="row-center" style="padding: 12px 16px 0">
      <button irxBoton="principal" (click)="activarNotificaciones()">
        Activar notificaciones
      </button>
    </div>
  }

  <app-listado-notificaciones></app-listado-notificaciones>
</mat-menu>
